import { Icon } from "./Icon";

const states = [
  ["Current", "Active board for this shot. Regenerate replaces it unless locked.", "Upload instead · Use existing · Lock"],
  ["Uploaded", "User-placed, source of truth. Generation never overwrites it.", "Replace · Remove"],
  ["Locked", "Pinned by the director. Skipped by every regenerate run.", "Upload instead · Lock"],
  ["Queued Regenerate", "Will be replaced on the next Generate Boards run.", "Upload instead · Lock"],
  ["Generating", "A storyboard job is currently filling this frame.", "Wait · Upload instead"],
  ["Generated", "Filled by ChatGPT Image and ready to keep, replace, or lock.", "Keep · Replace · Lock"],
  ["Failed", "Generation did not complete. The prompt and existing board are preserved.", "Retry · Upload instead"],
  ["Disabled", "Kept in the project, excluded from package and prompt.", "Upload instead · Enable"]
];

export function FrameStatesLegend() {
  return (
    <section className="frame-state-legend" aria-label="Storyboard frame states">
      <header>
        <div>
          <strong>Storyboard frame states</strong>
          <span>One rule: uploads and locks always win.</span>
        </div>
      </header>
      <div>
        {states.map(([label, description, action]) => (
          <article key={label}>
            <span>{label}</span>
            <p>{description}</p>
            <button type="button">
              <Icon name="upload" />
              {action}
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}
